import React from "react";

import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";

import Footer from '@refere/ui-utils/ui/components/Footer';

import Lead from "./Lead";
import Header from "./components/Header";

import { useHookstate } from "@hookstate/core";

import globalState from "../features/global-state";

const Home = () => {
    const simulacaoState = useHookstate(globalState.simulacaoState)

    const match800 = useMediaQuery("(max-width: 800px)");

    return (
        <>
            <Box
                display="flex"
                justifyContent="center"
            >
                <Box
                    p={match800 ? 1 : 3}
                    pb={3}
                    width="100%"
                    sx={{ maxWidth: t => `${t.breakpoints.values.lg}px` }}
                    position="relative"
                >
                    <Header />
                    <Lead />
                    <Box
                        px={match800 ? 1 : 3}
                        width="100%"
                        height="20px"
                        position="absolute"
                        bottom={0}
                        left={0}
                    >
                        <Footer
                            nomeSistema='MAG CAPITALIZAÇÃO'
                            nomeCorretora={simulacaoState.corretoraNome?.get()}
                        />
                    </Box>
                </Box>
            </Box>
        </>
    );
}

export default Home;